export default __webpack_public_path__ + "images/1a6e22b5b425ecf2467a4c8e26e10b8e-emoji-rested.svg";